module.exports = function() {
  return new Worker("/" + "unzip_imgs.worker.edcbe15557553cb03a87.js");
};